import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PayService } from '../service/pay.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Modal } from 'bootstrap';


function passwordMatchValidator(g: UntypedFormGroup) {
  return g.get('password').value === g.get('confirmPassword').value
    ? null : { 'mismatch': true };
}

@Component({
    selector: 'app-caissier',
    templateUrl: './caissier.component.html',
    styleUrls: ['./caissier.component.css'],
    standalone: false
})
export class CaissierComponent implements OnInit {
  bAccountid: any;
  bDescription: any;
  CaissierForm: UntypedFormGroup;

  emailexist: boolean = false;
  phonexist: boolean = false;
  loader: boolean = false;
  validation: boolean = false;
  letterchange: boolean = false;
  capitalchange: boolean = false;
  numberchange: boolean = false;
  lengthchange: boolean = false;
  symbolechange: boolean = false;

  isCameroun: boolean = false;
  added: boolean;
  caisierlist: any[];
  emailcaissier: any;
  isedit: boolean;
  caisierid: any;
  modalRef: Modal;

  constructor(private userService: PayService, private routerActivate: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    window.scroll(0,0)
    this.routerActivate.params.subscribe(params => {
      this.bAccountid = params['id'];
      this.bDescription = params['name']
    });
    this.ngCaissierForm();
    this.afficherLesCaisiers();
  }

  ngCaissierForm() {
    this.CaissierForm = new UntypedFormGroup({
      firstName: new UntypedFormControl('', [Validators.required, Validators.minLength(3)]),
      lastName: new UntypedFormControl('', [Validators.required, Validators.minLength(3)]),
      email: new UntypedFormControl('', [Validators.required, Validators.pattern("[^ @]*@[^ @]*[.][^ @]{2,}")]),
      password: new UntypedFormControl('', [Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}')]),
      confirmPassword: new UntypedFormControl('', [Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}')]),
    }, passwordMatchValidator)
  }

  generateEmail(value) {
    let email = value.replace(/\s/g, "") + "@" + "spay.africa";
    this.CaissierForm.get('email').setValue(email);
    this.CaissierForm.get('email').statusChanges;
  }

  addCaissier(formdata) {
    if (this.isedit) {
      this.userService.updateCaisierInformation(this.bAccountid, this.caisierid, formdata).subscribe(data => {
        if (data == 0) {
          this.added = true;
          this.afficherLesCaisiers();
          this.closeModal();
          setTimeout(() => {
            this.added = false;
          }, 4000);
        }
      })
    }
    else {
      this.userService.saveCaissier(this.bAccountid, formdata).subscribe(data => {
        if (data == 0) {
          this.added = true;
          this.afficherLesCaisiers();
          this.closeModal();
          setTimeout(() => {
            this.added = false;
          }, 4000);
        }
      })
    }

  }

  editer(id, caissier) {
    this.isedit = true;
    this.caisierid = id;
    this.CaissierForm.get('firstName').setValue(caissier['firstName']);
    this.CaissierForm.get('lastName').setValue(caissier['lastName']);
    this.CaissierForm.get('email').setValue(caissier['username']);
    this.emailcaissier = caissier['username'];
    this.openModal();

  }

  afficherLesCaisiers() {
    this.userService.getCaissiers(this.bAccountid).subscribe((data: any[]) => {
      this.caisierlist = data;
    })
  }


  isEmail(email) {
    if (this.emailcaissier == email) {
    }
    else {
      this.userService.findEmail(email).subscribe(res => {
        this.emailexist = !res.success;
        if (this.emailexist) {
          setTimeout(() => {
            this.emailexist = false;
          }, 4000);
        }
      }, err => {
        // console.log(err)
      })
    }


  }


  isPhone(phone) {

    this.userService.findPhone(phone).subscribe(res => {
      this.phonexist = !res.success;
    }, err => {

    })

  }
  showvalidationpart() {
    this.validation = true;
  }
  hidevalidationpart() {
    this.validation = false;

  }
  validateValue(textValue) {
    var lowerCaseLetters = /[a-z]/g;
    var myInput = document.getElementById("pass");
    var letter = document.getElementById("letter");
    if (this.CaissierForm.get('password').value.match(lowerCaseLetters)) {
      this.letterchange = true;
    } else {
      this.letterchange = false;
    }

    var upperCaseLetters = /[A-Z]/g;
    if (this.CaissierForm.get('password').value.match(upperCaseLetters)) {
      this.capitalchange = true;
    } else {
      this.capitalchange = false;
    }

    // Validate numbers
    var numbers = /[0-9]/g;
    if (this.CaissierForm.get('password').value.match(numbers)) {
      this.numberchange = true;

    } else {
      this.numberchange = false;
    }

    // Validate length
    if (this.CaissierForm.get('password').value.length >= 8 && this.CaissierForm.get('password').value.length < 17) {
      this.lengthchange = true
    } else {
      this.lengthchange = false
    }
    var symbole = /[$@$!%*?&]/g
    if (this.CaissierForm.get('password').value.match(symbole)) {
      this.symbolechange = true;

    } else {
      this.symbolechange = false;
    }

  }

  get firstName() { return this.CaissierForm.get('firstName'); }
  get lastName() { return this.CaissierForm.get('lastName'); }
  get email() { return this.CaissierForm.get('email'); }
  get phone() { return this.CaissierForm.get('phone'); }
  get password() { return this.CaissierForm.get('password'); }
  get confirmPassword() { return this.CaissierForm.get('confirmPassword'); }

  openModal() {
    const el = document.getElementById('caissierModal');
    if (el) {
      this.modalRef = Modal.getOrCreateInstance(el);
      this.modalRef.show();
    }
  }

  closeModal() {
    if (this.modalRef) {
      this.modalRef.hide();
    }
    document.body.classList.remove('modal-open');
    const backdrops = document.querySelectorAll('.modal-backdrop');
    backdrops.forEach(b => b.remove());
  }

  startCreate() {
    this.isedit = false;
    this.CaissierForm.reset();
    this.openModal();
  }



}
